import React, { useState } from "react";
import { t } from "../../../../../utils/i18n";

const DisputeInfo = ({ isDisputed, disputeData }) => {
  const [copied, setCopied] = useState(null);

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied(field);
    setTimeout(() => setCopied(false), 2000);
};
  return (
    <div>
      <p className="tradedetails-tradeinfo-title">
        <i className="fas fa-info-circle"></i>
        <span>{t("p2p.dispute_info.title")}</span>
      </p>
      <div>
        <div className="tradedetails-tradeinfo-specifics">
          {!isDisputed && (
            <div className="tradedetails-tradeinfo-specifics-text">
              <p className="tradedetails-tradeinfo-specifics-textvalues">
                {t("p2p.dispute_info.none")}
              </p>
            </div>
          )}
          {isDisputed && (
            <div className="tradedetails-tradeinfo-specifics">
              <div className="tradedetails-tradeinfo-specifics-text">
                <p
                  className="tradedetails-tradeinfo-specifics-textnames"
                >
                  <i className="fa fa-hourglass-half"></i>
                  {" "}{t("p2p.dispute_info.status")}
                </p>
                <span className="tradedetails-tradeinfo-specifics-textvalues disputeinfo-disputestatus">{disputeData?.status}</span>
              </div>
              <div className="tradedetails-tradeinfo-specifics-text">
                <p
                  className="tradedetails-tradeinfo-specifics-textnames"
                >
                  <i className="fas fa-bullseye"></i>
                  {" "}{t("p2p.dispute_info.id")}
                </p>
                <p className="tradedetails-tradeinfo-specifics-textvalues">{disputeData?.id}
                  <button onClick={() => handleCopy(disputeData.id, "disputeData.id")} className="tradedetails-copybtn">
                    <i className={`fas fa-${copied === "disputeData.id" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                  </button>
                </p>
              </div>
              <div className="tradedetails-tradeinfo-specifics-text">
                <p
                  className="tradedetails-tradeinfo-specifics-textnames"
                >
                  <i className="fa fa-thumbtack"></i> 
                  {" "}{t("p2p.dispute_info.notes")}
                </p>
                <span className="tradedetails-tradeinfo-specifics-textvalues">{disputeData?.user_note || t("p2p.dispute_info.notes_none")}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DisputeInfo;
